import { jsx as _jsx } from "react/jsx-runtime";
import { Markdown } from '../../markdown';
import { OperationSectionBody } from './OperationSectionBody';
export function OperationOverviewSection({ operation }) {
    const { description } = operation;
    return (_jsx(OperationSectionBody, { children: _jsx("div", { className: "py-3", children: _jsx(Markdown, { content: description }) }) }));
}
